import React from 'react';

import { USER_STATUS } from '../../constants';
import FiltersSelectContent from '../FiltersSelectContent';

interface FilterUserStatusPorps {}

const FilterUserStatus: React.FC<FilterUserStatusPorps> = () => (
  <FiltersSelectContent type="status" items={USER_STATUS} />
);
export default FilterUserStatus;
